import comp from "./StudentAlerts";
import StudentAlertsWrapper from "./StudentAlertsWrapper";

export default comp;
export { StudentAlertsWrapper };
